import { LessonPin } from '@lessonup/teaching-core';
import { ContentImageData } from '@lessonup/typescript-core/domain';
import { IframeMessaging } from '@lessonup/typescript-core/utils';
import { Button } from '@lessonup/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { PIN_SEARCH_TRANSLATION_NS } from '../PinSearchPage';

interface ImageResultProps {
  pin: LessonPin;
  images: ContentImageData | undefined;
}

const handleImageResolve = (url: string | undefined) => {
  if (!url) return;
  IframeMessaging.send('image-url', url);
};

export const ImageResult: React.FunctionComponent<ImageResultProps> = ({ pin, images }) => {
  const { t } = useTranslation(PIN_SEARCH_TRANSLATION_NS);
  if (!images || !images.main) return null;
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events -- auto-generated TECH-258
    <div className="image-result" key={pin._id} onClick={() => handleImageResolve(images.main && images.main.url)}>
      <div className={`pin-size-${400}`}>
        <div className="image" style={{ backgroundImage: `url(${images.main.url}` }}></div>
      </div>
      <div className="actions">
        <Button buttonType="primary">{t('useInLesson')}</Button>
      </div>
    </div>
  );
};
